// extracted by mini-css-extract-plugin
module.exports = {"menu":"Menu_menu__U1gF8","tabText":"Menu_tabText__7___E","carSale":"Menu_carSale__awuxw"};